export default "__VITE_ASSET__7465b156__"